import { message } from 'antd'
import { RFQApi } from '../../../../api/Sales/RFQ'
import RFQLines from '../../../../components/Purchasing/RFQ/Lines/RFQLines'
import useSelectionTable from '../../../../elements/Hooks/useSelectionTable'
import useSubmit from '../../../../elements/Hooks/useSubmit'
import { pick } from 'lodash'
import React from 'react'

import useFetchList from '../../../../elements/Hooks/useFetchList'
import useModalData from '../../../../elements/Hooks/useModalData'

function RFQLinesCont(props) {
  const { rfq, isUpdatable } = props
  const { list, fetching, fetch } = useFetchList(() => RFQApi.getLinesByRFQ(rfq._key))

  const {
    visible,
    modalType,
    object: line,
    submitting,
    setSubmitting,
    // removing,
    remove,
    formRef,
    onShow,
    onCancel,
    checkForm,
    update,
  } = useModalData(undefined, RFQApi.lines.update, RFQApi.lines.remove, fetch)

  async function submit() {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await RFQApi.lines.create({ ...newObject, rfq: pick(rfq, '_id') })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  const {
    tableRef,
    selection,
    selectAll,
    setSelection,
    toggleSelection,
    toggleAll,
    isSelected,
  } = useSelectionTable()

  const [removing, removeFunc] = useSubmit(RFQApi.lines.removeBulk)

  async function removeSelection() {
    setSubmitting(true)
    setSelection([])
    try {
      await removeFunc({ selection })
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <RFQLines
      {...{
        list,
        isUpdatable,
        fetching,
        fetch,
        visible,
        submitting,
        rfq,
        line,
        onShow,
        onCancel,
        submit,
        removing,
        remove,
        update,
        modalType,
        formRef,
        removeSelection,
        tableRef,
        selection,
        selectAll,
        setSelection,
        toggleSelection,
        toggleAll,
        isSelected,
      }}
    />
  )
}

RFQLinesCont.propTypes = {}
RFQLinesCont.defaultProps = {}

export default RFQLinesCont
